import React, {
  DetailedHTMLProps,
  KeyboardEventHandler,
  forwardRef,
  useCallback,
  useMemo,
} from "react";
import classNames from "classnames";
import SearchIcon from "@mui/icons-material/Search";
import { SearchButtonWrapper, SearchInputContainer, SearchInputStyled, SearchInputWrap } from "./style";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

export interface SearchInputProps
  extends Omit<DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >, 'ref'> {
  className?: string;
  onClickSearch: any;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(({
  className,
  onClickSearch,
  placeholder = "Buscar...",
  ...inputProps
}, ref) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(420));
  const wrapperClassName = useMemo(
    () =>
      classNames({
        "xvia-search-input": true,
        [className as string]: !!className,
      }),
    [className]
  );
  const value = (inputProps.value ?? "") as string;

  const keyDownHandler = useCallback<KeyboardEventHandler<HTMLInputElement>>(
    (event) => {
      if (event.key === "Enter") {
        onClickSearch(value);
      }
    },
    [onClickSearch, value]
  );

  return (
    <div className={wrapperClassName}>
      <SearchInputWrap>
        <SearchInputContainer>
          <SearchIcon />
          <SearchInputStyled
            ref={ref}
            onKeyDown={keyDownHandler}
            className="xvia-catalog-search-input__input"
            type="text"
            name="keyword"
            aria-label="Campo de busca"
            placeholder={placeholder}
            {...inputProps}
          />
        </SearchInputContainer>
        <SearchButtonWrapper>
          <button onClick={() => onClickSearch(value)} aria-label="Buscar">{isSmallScreen ? <SearchIcon fontSize="small" /> : "Buscar"}</button>
        </SearchButtonWrapper>
      </SearchInputWrap>
    </div>
  );
});
